<template>
  <v-container>

    <v-card>
      <v-toolbar flat color="blue accent-2" class="white--text">
        <v-btn to="/" icon text>
          <v-icon small class="white--text">mdi-home</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h3 class="font-weight-light">Posts de la comunidad</h3>
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>

        <loader v-if="isloading"></loader>

        <v-row dense>
          <v-col cols="12">
            <v-data-table :search="search" :headers="headers" :items="items" disable-pagination hide-default-footer item-key="key" class="elevation-1 mt-6">

              <template v-slot:item.image="{ item }">
                <img v-if="item.image[0]" class="mt-2 mb-2" height="50" width="50" :src="`${$awsPath}/${item.image[0]}`" alt="">
                <img v-else class="mt-2 mb-2" height="50" width="50" src="/default-image.jpg" alt="">
              </template>

              <template v-slot:item.usuario="{ item }">
                {{ item.userId ? `${item.userId.name} ${item.userId.last_name}` : 'N/A'}}
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon @click="openModal(item)" small class="mr-2" color="green">
                  mdi-chat-processing
                </v-icon>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>

    <v-confirm-dialog v-on:delete="deletePost">
    </v-confirm-dialog>

    <modal-comentarios></modal-comentarios>

  </v-container>
</template>

<script>
  import {
    post_service
  } from '~/post_service'

  import modalComentarios from './modalComentarios'

  export default {

    components: {
      'modal-comentarios': modalComentarios
    },

    data() {
      return {
        item: {},

        items: [],

        search: null,

        headers: [{
            text: 'Imagen',
            value: 'image',
          },
          {
            text: 'Descripción',
            value: 'description',
            width: 400
          },
          {
            text: 'Usuario',
            value: 'usuario',
          },
          {
            text: 'Replies',
            value: 'commentLength',
            width: 30,
            align: 'center',
            sortable: false,
          },
          {
            text: 'Acciones',
            value: 'action',
            sortable: false
          },
        ],
      }
    },

    created() {
      this.getPosts()
    },

    methods: {
      openModal(item) {
        this.$emit('open_modal', item)
      },
      getPosts() {
        post_service.get_post_by_admin(this.user.id).then(res => {
          this.items = res.data
        }, res => {
          this.$toast.error('Error consultando posts')
        })
      },

      openConfirmDialog(item) {
        this.item = item
        this.$emit('confirm_open')
      },

      deletePost() {
        post_service.delete_post(this.item.id).then(res => {
          this.items.splice(this.items.indexOf(this.item), 1)
          this.$toast.sucs('Registro eliminado con exito')
          this.item = {}
        }, res => {
          this.$toast.error('Error eliminando registro')
        })
      }

    },
    computed: {
      isloading() {
        return this.$store.getters.getloading
      },
      errors() {
        return this.$store.getters.geterrors
      },
      user() {
        return JSON.parse(localStorage.getItem('user'))
      },
      categoria() {
        return this.$store.getters.get_categoria
      }
    }
  }
</script>